function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:url(#Ouro);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 36.5,
  cy: 36.5,
  r: 36.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M35.6,47.9l-7.7,4c-0.3,0.2-0.7,0.2-1.1,0.2s-0.7-0.2-1-0.4s-0.5-0.5-0.7-0.9c-0.1-0.3-0.2-0.7-0.1-1.1l1.5-8.6 L20.3,35c-0.3-0.3-0.4-0.6-0.5-0.9c-0.1-0.4-0.1-0.7,0-1.1c0.1-0.3,0.3-0.7,0.6-0.9c0.3-0.2,0.6-0.4,1-0.4l8.6-1.3l3.9-7.8 c0.2-0.3,0.4-0.6,0.7-0.8c0.3-0.2,0.7-0.3,1-0.3c0.4,0,0.7,0.1,1,0.3c0.3,0.2,0.6,0.5,0.7,0.8l3.8,7.8l8.6,1.3 c0.4,0.1,0.7,0.2,1,0.4s0.5,0.5,0.6,0.9c0.1,0.3,0.1,0.7,0,1.1c-0.1,0.4-0.3,0.7-0.5,0.9l-6.2,6.1l1.5,8.6c0.1,0.4,0,0.7-0.1,1.1 c-0.1,0.3-0.4,0.6-0.7,0.9c-0.3,0.2-0.6,0.3-1,0.4c-0.4,0-0.7,0-1.1-0.2L35.6,47.9z"
});

var SvgOuro = function SvgOuro(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 73 73",
    style: {
      enableBackground: "new 0 0 73 73"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ouro",
    gradientUnits: "userSpaceOnUse",
    x1: -1193.2739,
    y1: -32.4971,
    x2: -1191.5027,
    y2: -33.1794,
    gradientTransform: "matrix(0.4229 36.9229 -36.9229 0.4229 -671.4382 44077.5312)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#835724"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2656,
    style: {
      stopColor: "#C2AC5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5194,
    style: {
      stopColor: "#F3ED83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7622,
    style: {
      stopColor: "#AC8F47"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#835724"
    }
  })), _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOuro, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ouro.074eee09.svg";
export { ForwardRef as ReactComponent };